import { TeamPointSummary } from 'services/openapi';

export const updateData = (data: TeamPointSummary[]) => {
  return data?.map(team => {
    const classesObject = {};
    team?.shows?.forEach(clss => {
      classesObject[clss?.showId!] = clss?.point;
    });
    return {
      ...team,
      ...classesObject,
    };
  });
};
export const showInfoData = {
  "season": {
    "id": "5ded80c3-10aa-43d4-9a8e-288118119d9c",
    "name": "Season 2025-2026"
  },
  "categories": [
    {
      "categoryId": "cea34360-a5aa-4a64-89a0-c509e08e190a",
      "categoryCode": "Sr. High",
      "categoryName": "Sr. High Team Results",
      "teams": [
        {
          "rank": 1,
          "teamCode": "BRT",
          "teamId": "78b12fc7-8358-4a15-991e-e4e36609ff81",
          "teamName": "Buckeye Riders",
          "teamUrl": "/team-profile/78b12fc7-8358-4a15-991e-e4e36609ff81",
          "totalPoints": 180,
          "top10Points": 180,
          "showResults": [
            {
              "showId": "7d95f4a5-8253-42d4-5a62-08de2cedacea",
              "showName": "University of Findlay Cancled Show ",
              "showDate": "12.13.25",
              "showStartDate": "2025-12-13",
              "showEndDate": "2025-12-14",
              "isNationalFinal": false,
              "isMultiDay": true,
              "points": 0
            },
            {
              "showId": "a7a262a8-b8f7-4b03-5a63-08de2cedacea",
              "showName": "University of Findlay Cancled Show ",
              "showDate": "12.13.25",
              "showStartDate": "2025-12-13",
              "showEndDate": "2025-12-14",
              "isNationalFinal": false,
              "isMultiDay": true,
              "points": 0
            },
            {
              "showId": "f8b161a2-6a99-4e05-afee-1f6a3af42252",
              "showName": "Miami Jr. Redhawks Holiday Hooplah* Sunday",
              "showDate": "12.07.25",
              "showStartDate": "2025-12-07",
              "showEndDate": "2025-12-07",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "67bec6e7-f733-44ac-a583-cc4989b4648f",
              "showName": "Miami Jr. Redhawks Holiday Hooplah* Saturday",
              "showDate": "12.06.25",
              "showStartDate": "2025-12-06",
              "showEndDate": "2025-12-06",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "b06e4477-b175-40ed-a1aa-2978f008f282",
              "showName": "Riding in the Rein Sunday",
              "showDate": "11.23.25",
              "showStartDate": "2025-11-23",
              "showEndDate": "2025-11-23",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "0e11ee52-ec0c-4b67-9303-9ca8186baf38",
              "showName": "Thanks' & Giving Weekend",
              "showDate": "11.22.25",
              "showStartDate": "2025-11-22",
              "showEndDate": "2025-11-22",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "b506c04d-4851-4683-bcae-e8ad4ed1e532",
              "showName": "Riding in the Rein Saturday",
              "showDate": "11.22.25",
              "showStartDate": "2025-11-22",
              "showEndDate": "2025-11-22",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "433f9c76-6e96-4655-bd77-4ffcb70db141",
              "showName": "Midwest Classic SUNDAY",
              "showDate": "11.16.25",
              "showStartDate": "2025-11-16",
              "showEndDate": "2025-11-16",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "5e3d5b1e-d26d-4e23-8e0a-343bc551ea3d",
              "showName": "Midwest Classic SATURDAY",
              "showDate": "11.15.25",
              "showStartDate": "2025-11-15",
              "showEndDate": "2025-11-15",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "075fd75e-b286-4221-8898-1b338a0f9ef1",
              "showName": "Blue Raiders Cup (Sunday)",
              "showDate": "11.09.25",
              "showStartDate": "2025-11-09",
              "showEndDate": "2025-11-09",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "cb4e5c88-455a-40bb-9033-60e40df0c06c",
              "showName": "PET Turkey Trot SUNDAY",
              "showDate": "11.09.25",
              "showStartDate": "2025-11-09",
              "showEndDate": "2025-11-09",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "bb49c026-dd0b-4463-a08a-7be9521c2a87",
              "showName": "PET Turkey Trot SATURDAY",
              "showDate": "11.08.25",
              "showStartDate": "2025-11-08",
              "showEndDate": "2025-11-08",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "41c87395-2d15-477e-951d-571c7804a931",
              "showName": "Blue Raiders Cup (Saturday) A",
              "showDate": "11.08.25",
              "showStartDate": "2025-11-08",
              "showEndDate": "2025-11-08",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "7f0d944e-7cb4-44c5-5ac2-08ddf657921b",
              "showName": "Molly's Test Show PET ????",
              "showDate": "11.08.25",
              "showStartDate": "2025-11-08",
              "showEndDate": "2025-11-09",
              "isNationalFinal": false,
              "isMultiDay": true,
              "points": 0
            },
            {
              "showId": "caeb5691-3ed1-445a-ab50-7da4a901e344",
              "showName": "Ghostly Gallop with YEDA",
              "showDate": "11.02.25",
              "showStartDate": "2025-11-02",
              "showEndDate": "2025-11-02",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 43
            },
            {
              "showId": "ca82342d-bb18-43bf-a06b-3f7e845a551c",
              "showName": "Ghostly Gallop with YEDA",
              "showDate": "11.01.25",
              "showStartDate": "2025-11-01",
              "showEndDate": "2025-11-01",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 43
            },
            {
              "showId": "baf4a424-8a24-423e-95b1-7d764c0398be",
              "showName": "Cedar Ridge Farm",
              "showDate": "11.01.25",
              "showStartDate": "2025-11-01",
              "showEndDate": "2025-11-01",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "d49b71b7-5dc1-4d37-b950-af4c08d87930",
              "showName": "Haunted Horses Show II M Sexton",
              "showDate": "10.19.25",
              "showStartDate": "2025-10-19",
              "showEndDate": "2025-10-19",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "b889afbc-8032-4cad-8bda-34cae3862193",
              "showName": "Haunted Horses Show II G Loper",
              "showDate": "10.19.25",
              "showStartDate": "2025-10-19",
              "showEndDate": "2025-10-19",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "43347bb8-8b0e-43c5-9416-d74bda2df16d",
              "showName": "Haunted Horses Show I D Massengale",
              "showDate": "10.18.25",
              "showStartDate": "2025-10-18",
              "showEndDate": "2025-10-18",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "154ea56b-ee29-4889-8bc3-dd7f83c9171b",
              "showName": "Haunted Horses Show I H Massengale",
              "showDate": "10.18.25",
              "showStartDate": "2025-10-18",
              "showEndDate": "2025-10-18",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "9d3b6892-76c2-4b68-82a2-d21565c7c155",
              "showName": "All American Quarter Horse Congress YEDA Show (B)",
              "showDate": "10.08.25",
              "showStartDate": "2025-10-08",
              "showEndDate": "2025-10-08",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 47
            },
            {
              "showId": "8028d356-c319-4389-aec0-9154e1212005",
              "showName": "All American Quarter Horse Congress YEDA Show",
              "showDate": "10.08.25",
              "showStartDate": "2025-10-08",
              "showEndDate": "2025-10-08",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 47
            },
            {
              "showId": "c7f91195-2eb9-4a15-b6f5-7cd714569f58",
              "showName": "Pondview Fall Show PM",
              "showDate": "10.05.25",
              "showStartDate": "2025-10-05",
              "showEndDate": "2025-10-05",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "1cc12fcf-182b-4da4-b4ca-1789ce0fd5c4",
              "showName": "Pondview Equestrian Fall Show AM",
              "showDate": "10.05.25",
              "showStartDate": "2025-10-05",
              "showEndDate": "2025-10-05",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "d581d7be-b12a-4ade-8e28-c7f58ade40a0",
              "showName": "Pondview Fall Show AM",
              "showDate": "10.05.25",
              "showStartDate": "2025-10-05",
              "showEndDate": "2025-10-05",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "a18a3675-e14e-4c61-b345-acc6a7f7e232",
              "showName": "The Legacy",
              "showDate": "09.21.25",
              "showStartDate": "2025-09-21",
              "showEndDate": "2025-09-21",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "1dc56871-2ac8-4440-8e80-099a53a3cf43",
              "showName": "The Legacy-JUDGE B",
              "showDate": "09.21.25",
              "showStartDate": "2025-09-21",
              "showEndDate": "2025-09-21",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            }
          ]
        },
        {
          "rank": 2,
          "teamCode": "SBA",
          "teamId": "4840a01c-e636-4345-b15c-4b4dc0ece33f",
          "teamName": "ShowBiz A",
          "teamUrl": "/team-profile/4840a01c-e636-4345-b15c-4b4dc0ece33f",
          "totalPoints": 149,
          "top10Points": 149,
          "showResults": [
            {
              "showId": "7d95f4a5-8253-42d4-5a62-08de2cedacea",
              "showName": "University of Findlay Cancled Show ",
              "showDate": "12.13.25",
              "showStartDate": "2025-12-13",
              "showEndDate": "2025-12-14",
              "isNationalFinal": false,
              "isMultiDay": true,
              "points": 0
            },
            {
              "showId": "a7a262a8-b8f7-4b03-5a63-08de2cedacea",
              "showName": "University of Findlay Cancled Show ",
              "showDate": "12.13.25",
              "showStartDate": "2025-12-13",
              "showEndDate": "2025-12-14",
              "isNationalFinal": false,
              "isMultiDay": true,
              "points": 0
            },
            {
              "showId": "f8b161a2-6a99-4e05-afee-1f6a3af42252",
              "showName": "Miami Jr. Redhawks Holiday Hooplah* Sunday",
              "showDate": "12.07.25",
              "showStartDate": "2025-12-07",
              "showEndDate": "2025-12-07",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "67bec6e7-f733-44ac-a583-cc4989b4648f",
              "showName": "Miami Jr. Redhawks Holiday Hooplah* Saturday",
              "showDate": "12.06.25",
              "showStartDate": "2025-12-06",
              "showEndDate": "2025-12-06",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "b06e4477-b175-40ed-a1aa-2978f008f282",
              "showName": "Riding in the Rein Sunday",
              "showDate": "11.23.25",
              "showStartDate": "2025-11-23",
              "showEndDate": "2025-11-23",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "0e11ee52-ec0c-4b67-9303-9ca8186baf38",
              "showName": "Thanks' & Giving Weekend",
              "showDate": "11.22.25",
              "showStartDate": "2025-11-22",
              "showEndDate": "2025-11-22",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "b506c04d-4851-4683-bcae-e8ad4ed1e532",
              "showName": "Riding in the Rein Saturday",
              "showDate": "11.22.25",
              "showStartDate": "2025-11-22",
              "showEndDate": "2025-11-22",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "433f9c76-6e96-4655-bd77-4ffcb70db141",
              "showName": "Midwest Classic SUNDAY",
              "showDate": "11.16.25",
              "showStartDate": "2025-11-16",
              "showEndDate": "2025-11-16",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "5e3d5b1e-d26d-4e23-8e0a-343bc551ea3d",
              "showName": "Midwest Classic SATURDAY",
              "showDate": "11.15.25",
              "showStartDate": "2025-11-15",
              "showEndDate": "2025-11-15",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "075fd75e-b286-4221-8898-1b338a0f9ef1",
              "showName": "Blue Raiders Cup (Sunday)",
              "showDate": "11.09.25",
              "showStartDate": "2025-11-09",
              "showEndDate": "2025-11-09",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "cb4e5c88-455a-40bb-9033-60e40df0c06c",
              "showName": "PET Turkey Trot SUNDAY",
              "showDate": "11.09.25",
              "showStartDate": "2025-11-09",
              "showEndDate": "2025-11-09",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "bb49c026-dd0b-4463-a08a-7be9521c2a87",
              "showName": "PET Turkey Trot SATURDAY",
              "showDate": "11.08.25",
              "showStartDate": "2025-11-08",
              "showEndDate": "2025-11-08",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "41c87395-2d15-477e-951d-571c7804a931",
              "showName": "Blue Raiders Cup (Saturday) A",
              "showDate": "11.08.25",
              "showStartDate": "2025-11-08",
              "showEndDate": "2025-11-08",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "7f0d944e-7cb4-44c5-5ac2-08ddf657921b",
              "showName": "Molly's Test Show PET ????",
              "showDate": "11.08.25",
              "showStartDate": "2025-11-08",
              "showEndDate": "2025-11-09",
              "isNationalFinal": false,
              "isMultiDay": true,
              "points": 0
            },
            {
              "showId": "caeb5691-3ed1-445a-ab50-7da4a901e344",
              "showName": "Ghostly Gallop with YEDA",
              "showDate": "11.02.25",
              "showStartDate": "2025-11-02",
              "showEndDate": "2025-11-02",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "ca82342d-bb18-43bf-a06b-3f7e845a551c",
              "showName": "Ghostly Gallop with YEDA",
              "showDate": "11.01.25",
              "showStartDate": "2025-11-01",
              "showEndDate": "2025-11-01",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "baf4a424-8a24-423e-95b1-7d764c0398be",
              "showName": "Cedar Ridge Farm",
              "showDate": "11.01.25",
              "showStartDate": "2025-11-01",
              "showEndDate": "2025-11-01",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "d49b71b7-5dc1-4d37-b950-af4c08d87930",
              "showName": "Haunted Horses Show II M Sexton",
              "showDate": "10.19.25",
              "showStartDate": "2025-10-19",
              "showEndDate": "2025-10-19",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 24
            },
            {
              "showId": "b889afbc-8032-4cad-8bda-34cae3862193",
              "showName": "Haunted Horses Show II G Loper",
              "showDate": "10.19.25",
              "showStartDate": "2025-10-19",
              "showEndDate": "2025-10-19",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 23
            },
            {
              "showId": "43347bb8-8b0e-43c5-9416-d74bda2df16d",
              "showName": "Haunted Horses Show I D Massengale",
              "showDate": "10.18.25",
              "showStartDate": "2025-10-18",
              "showEndDate": "2025-10-18",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 32
            },
            {
              "showId": "154ea56b-ee29-4889-8bc3-dd7f83c9171b",
              "showName": "Haunted Horses Show I H Massengale",
              "showDate": "10.18.25",
              "showStartDate": "2025-10-18",
              "showEndDate": "2025-10-18",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 31
            },
            {
              "showId": "9d3b6892-76c2-4b68-82a2-d21565c7c155",
              "showName": "All American Quarter Horse Congress YEDA Show (B)",
              "showDate": "10.08.25",
              "showStartDate": "2025-10-08",
              "showEndDate": "2025-10-08",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 21
            },
            {
              "showId": "8028d356-c319-4389-aec0-9154e1212005",
              "showName": "All American Quarter Horse Congress YEDA Show",
              "showDate": "10.08.25",
              "showStartDate": "2025-10-08",
              "showEndDate": "2025-10-08",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 18
            },
            {
              "showId": "c7f91195-2eb9-4a15-b6f5-7cd714569f58",
              "showName": "Pondview Fall Show PM",
              "showDate": "10.05.25",
              "showStartDate": "2025-10-05",
              "showEndDate": "2025-10-05",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "1cc12fcf-182b-4da4-b4ca-1789ce0fd5c4",
              "showName": "Pondview Equestrian Fall Show AM",
              "showDate": "10.05.25",
              "showStartDate": "2025-10-05",
              "showEndDate": "2025-10-05",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "d581d7be-b12a-4ade-8e28-c7f58ade40a0",
              "showName": "Pondview Fall Show AM",
              "showDate": "10.05.25",
              "showStartDate": "2025-10-05",
              "showEndDate": "2025-10-05",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "a18a3675-e14e-4c61-b345-acc6a7f7e232",
              "showName": "The Legacy",
              "showDate": "09.21.25",
              "showStartDate": "2025-09-21",
              "showEndDate": "2025-09-21",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            },
            {
              "showId": "1dc56871-2ac8-4440-8e80-099a53a3cf43",
              "showName": "The Legacy-JUDGE B",
              "showDate": "09.21.25",
              "showStartDate": "2025-09-21",
              "showEndDate": "2025-09-21",
              "isNationalFinal": false,
              "isMultiDay": false,
              "points": 0
            }
          ]
        },
      ]
    },],
}
